import React from 'react'
import * as  C from "../componentsM/index"
import { Link } from 'react-router-dom'

const MYP = () => {
    return (
        <>

            <C.Hero title={"MYP GRADUATION REQUIREMENTS"}
                image={"/hero/11.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>


                    <p>The IB Organisation will award an IB MYP Certificate to each candidate who has:</p>




                    <ul className="list-disc list-inside my-2">
                        {[
                            "Gained a grade total of at least 28 out of a possible maximum of 56, and gained at least a grade 3 in each of the six subjects, interdisciplinary on-screen examination and the personal project.",
                            "Completed the school’s requirements for community service."
                        ]
                            .map((item, index) => (
                                <li key={index} className="text-sm">{item}</li>
                            ))}
                    </ul>

                    <p>A grade from at least one subject from each of the following six subject groups must contribute to the award of the certificate:</p>

                    <ul className="list-disc list-inside my-2">
                        {[
                            "Language and literature",
                            "Language acquisition",
                            "Individuals and societies",
                            "Mathematics",
                            "Sciences",
                            "Arts / Physical and Health Education/ Design"
                        ]
                            .map((item, index) => (
                                <li key={index} className="text-sm">{item}</li>
                            ))}
                    </ul>


                    <p>Students may register for any number of subjects (more than one science), but only six subjects contribute to the award of the certificate. If a candidate takes more than one subject from the same subject group, the highest grade will count towards the <Link to={"/not"} className='text-myBlue/60'>MYP certificate.</Link></p>

                </div>
            </section>

        </>

    )
}

export default MYP